/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";

import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
  MuiThemeProvider,
} from "@material-ui/core/styles";

import {
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";

import { lightBlue } from "@material-ui/core/colors";
import { SalesforceConfig, ServicenowConfig } from "../TicketConfig";

import toPx from "unit-to-px";
import Ticket from "../Ticket.js";
import Actions from "../../../fluid/Actions/ActionFactory.js";

import PDFViewer from "./PDFViewer";
const styles = (theme) => ({
  text_field: {
    width: "30%",
  },

  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },

  divider: {
    margin: "8px 0px",
  },

  modules: {
    marginRight: "12px",
  },
});

const blueTheme = createMuiTheme({
  palette: {
    primary: {
      main: lightBlue[600],
    },
  },
  typography: {
    useNextVariants: true,
    h6: {
      fontSize: "0.95rem",
      lineHeight: 1.3,
    },
    body2Next: {
      fontSize: "0.75rem",
    },
  },
});

class ResultViewer extends Component {
  state = {};

  componentWillMount() {}

  renderDetailViewer = () => {
    let selectedResult = this.props.selectedResult;
    let selectedItemType =
      selectedResult.iu_record_src_info.iu_content_type.sub_class;
    if (
      selectedItemType == "ticket" ||
      selectedItemType == "csv" ||
      selectedItemType == "sm"
    ) {
      let displayLabels;
      //  let config = { result: this.state.detailViewerdata, displayLabels: displayLabels }
      {
        /* let iuType = selectedResult.iu_record_world_view.wv_id_str.IU_key.user_friendly_name;
            if( iuType == 'salesforce'){
                displayLabels = SalesforceConfig.displayLabels;
            } else if( iuType == 'servicenow') {
                displayLabels = ServicenowConfig.displayLabels;
            } */
      }

      displayLabels = SalesforceConfig.displayLabels;
      let config = {
        result: this.props.detailViewerdata,
        displayLabels: displayLabels,
      };

      return <Ticket config={config} type={"result"} escalate={"false"} />;
    } else if (selectedItemType == "pdf") {
      let link =
        selectedResult.iu_record_src_info.iu_record_nav_info.source[0].link;
      let source_link = selectedResult.source_link;
      let pageNumber =
        selectedResult.iu_record_src_info.iu_record_nav_info.location.position;
      //let src = javascript;

      // let fileToDisplay = this.getPDFLink(link);
      let fileToDisplay = selectedResult.pdf_link;
      return (
        <div
          style={{
            height: "calc(100vh - 265px)",
          }}
        >
          <PDFViewer
            src={fileToDisplay}
            filename={link}
            width={68}
            height={((toPx("vh") * 90 - 90) / (toPx("vh") * 100)) * 100}
            pageNumber={parseInt(pageNumber)}
            downloadUrl={fileToDisplay} /* Hardcoding the download url */
            highlight=""
            //nextPage = {(pageNumber) => this.nextPage(pageNumber)}
            //prevPage = {(pageNumber) => this.prevPage(pageNumber)}
            //  setPage = {(event) => this.setPage(event)}
          />
        </div>
      );
    }
  };

  nextPage = (pageNum) => {
    this.setState({
      pageNumber: parseInt(pageNum) + 1,
    });
  };

  prevPage = (pageNum) => {
    this.setState({
      pageNumber: parseInt(pageNum) + 1,
    });
  };

  render() {
    //  this.getObj()

    const { classes } = this.props;
    return (
      <MuiThemeProvider theme={blueTheme}>
        {this.renderDetailViewer()}
      </MuiThemeProvider>
    );
  }
}

export default withStyles(styles)(ResultViewer);
